<template>
  <div v-if="rounds.length" class="content">
    <h1 class="title" v-if="loading">een moment geduld alstublieft...</h1>
    <template v-else-if="confirmed">
      <h1 class="title" v-if="!replay">Je stem is bevestigd!</h1>
      <h1 class="title" v-if="replay">Je stem was bevestigd</h1>

      <div class="card card--centered">
        <p v-if="votedNominees.length" class="votes">
          <template v-for="nominee in votedNominees">
            <div v-if="nominee.type === 'dutchrealityawards_nominees'" class="selection__image__container">
              <div v-if="nominee.url" class="nomineeUrl">
                <a target="_blank" :href="nominee.url">
                  <svg
                    class="url__icon"
                    viewBox="0 0 256 256"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMidYMid"
                  >
                    <g>
                      <path
                        d="M127.999746,23.06353 C162.177385,23.06353 166.225393,23.1936027 179.722476,23.8094161 C192.20235,24.3789926 198.979853,26.4642218 203.490736,28.2166477 C209.464938,30.5386501 213.729395,33.3128586 218.208268,37.7917319 C222.687141,42.2706052 225.46135,46.5350617 227.782844,52.5092638 C229.535778,57.0201472 231.621007,63.7976504 232.190584,76.277016 C232.806397,89.7746075 232.93647,93.8226147 232.93647,128.000254 C232.93647,162.177893 232.806397,166.225901 232.190584,179.722984 C231.621007,192.202858 229.535778,198.980361 227.782844,203.491244 C225.46135,209.465446 222.687141,213.729903 218.208268,218.208776 C213.729395,222.687649 209.464938,225.461858 203.490736,227.783352 C198.979853,229.536286 192.20235,231.621516 179.722476,232.191092 C166.227425,232.806905 162.179418,232.936978 127.999746,232.936978 C93.8200742,232.936978 89.772067,232.806905 76.277016,232.191092 C63.7971424,231.621516 57.0196391,229.536286 52.5092638,227.783352 C46.5345536,225.461858 42.2700971,222.687649 37.7912238,218.208776 C33.3123505,213.729903 30.538142,209.465446 28.2166477,203.491244 C26.4637138,198.980361 24.3784845,192.202858 23.808908,179.723492 C23.1930946,166.225901 23.0630219,162.177893 23.0630219,128.000254 C23.0630219,93.8226147 23.1930946,89.7746075 23.808908,76.2775241 C24.3784845,63.7976504 26.4637138,57.0201472 28.2166477,52.5092638 C30.538142,46.5350617 33.3123505,42.2706052 37.7912238,37.7917319 C42.2700971,33.3128586 46.5345536,30.5386501 52.5092638,28.2166477 C57.0196391,26.4642218 63.7971424,24.3789926 76.2765079,23.8094161 C89.7740994,23.1936027 93.8221066,23.06353 127.999746,23.06353 M127.999746,0 C93.2367791,0 88.8783247,0.147348072 75.2257637,0.770274749 C61.601148,1.39218523 52.2968794,3.55566141 44.1546281,6.72008828 C35.7374966,9.99121548 28.5992446,14.3679613 21.4833489,21.483857 C14.3674532,28.5997527 9.99070739,35.7380046 6.71958019,44.1551362 C3.55515331,52.2973875 1.39167714,61.6016561 0.769766653,75.2262718 C0.146839975,88.8783247 0,93.2372872 0,128.000254 C0,162.763221 0.146839975,167.122183 0.769766653,180.774236 C1.39167714,194.398852 3.55515331,203.703121 6.71958019,211.845372 C9.99070739,220.261995 14.3674532,227.400755 21.4833489,234.516651 C28.5992446,241.632547 35.7374966,246.009293 44.1546281,249.28042 C52.2968794,252.444847 61.601148,254.608323 75.2257637,255.230233 C88.8783247,255.85316 93.2367791,256 127.999746,256 C162.762713,256 167.121675,255.85316 180.773728,255.230233 C194.398344,254.608323 203.702613,252.444847 211.844864,249.28042 C220.261995,246.009293 227.400247,241.632547 234.516143,234.516651 C241.632039,227.400755 246.008785,220.262503 249.279912,211.845372 C252.444339,203.703121 254.607815,194.398852 255.229725,180.774236 C255.852652,167.122183 256,162.763221 256,128.000254 C256,93.2372872 255.852652,88.8783247 255.229725,75.2262718 C254.607815,61.6016561 252.444339,52.2973875 249.279912,44.1551362 C246.008785,35.7380046 241.632039,28.5997527 234.516143,21.483857 C227.400247,14.3679613 220.261995,9.99121548 211.844864,6.72008828 C203.702613,3.55566141 194.398344,1.39218523 180.773728,0.770274749 C167.121675,0.147348072 162.762713,0 127.999746,0 Z M127.999746,62.2703115 C91.698262,62.2703115 62.2698034,91.69877 62.2698034,128.000254 C62.2698034,164.301738 91.698262,193.730197 127.999746,193.730197 C164.30123,193.730197 193.729689,164.301738 193.729689,128.000254 C193.729689,91.69877 164.30123,62.2703115 127.999746,62.2703115 Z M127.999746,170.667175 C104.435741,170.667175 85.3328252,151.564259 85.3328252,128.000254 C85.3328252,104.436249 104.435741,85.3333333 127.999746,85.3333333 C151.563751,85.3333333 170.666667,104.436249 170.666667,128.000254 C170.666667,151.564259 151.563751,170.667175 127.999746,170.667175 Z M211.686338,59.6734287 C211.686338,68.1566129 204.809755,75.0337031 196.326571,75.0337031 C187.843387,75.0337031 180.966297,68.1566129 180.966297,59.6734287 C180.966297,51.1902445 187.843387,44.3136624 196.326571,44.3136624 C204.809755,44.3136624 211.686338,51.1902445 211.686338,59.6734287 Z"
                      ></path>
                    </g>
                  </svg>
                </a>
              </div>
              <img class="vote" v-if="nominee.image" :src="nominee.image.data.src" :key="nominee.id" />
              <b style="position: absolute; bottom: 0; right: 0; left: 0; z-index: 1">{{ nominee.name }} </b>
            </div>

            <div v-else-if="nominee.type === 'voting_suggestions'" class="vote">
              <b style="position: absolute; bottom: 0; right: 0; left: 0">{{ nominee.name }} </b>
              <img src="static/base_icon.png" />
            </div>
          </template>
        </p>
        <div class="html html--centered">
          <p>Bedankt voor het stemmen!</p>
          <p>Vergeet niet om je stem te delen met je vrienden via Whatsapp, Facebook of X!</p>
        </div>

        <div class="share">
          <a
            class="share__button"
            :href="`https://web.whatsapp.com`"
            rel="noopener"
            target="_blank"
            title="Deel op Whatsapp"
            @click.prevent="whatsapp({ text: shareText, url: shareUrl })"
          >
            <svg viewBox="0 0 448 512">
              <path
                fill="#d9a22e"
                d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
              />
            </svg>
          </a>
          <a
            class="share__button"
            :href="`https://facebook.com`"
            rel="noopener"
            target="_blank"
            title="Deel op Facebook"
            @click.prevent="facebook({ text: shareText, url: shareUrl })"
          >
            <svg viewBox="0 0 512 512">
              <path
                fill="#d9a22e"
                d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"
              />
            </svg>
          </a>

          <a
            class="share__button"
            :href="`https://x.com`"
            rel="noopener"
            target="_blank"
            title="Deel op X"
            @click.prevent="twitter({ text: shareText, url: shareUrl })"
          >
            <svg viewBox="0 0 1200 1222">
              <path
                fill="#d9a22e"
                d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"
              />
            </svg>
          </a>
        </div>
      </div>
    </template>

    <div v-else-if="notFound" class="card">
      <p>Deze bevestigings link is ongeldig.</p>
    </div>
  </div>
  <div v-else class="card">
    <p>Er kan op dit moment niet (meer) gestemd worden.</p>
  </div>
</template>

<script>
import { get } from '@/util/request'
import { facebook, twitter, whatsapp } from '@/util/share'
const { FRONTEND_DOMAIN = document.location.origin } = process.env
export default {
  name: 'Confirm',
  data() {
    return {
      loading: true,
      confirmed: false,
      replay: false,
      notFound: false,
      nomineeIds: [],
      votedNominees: [],
      suggestions: [],
      shareUrl: FRONTEND_DOMAIN
    }
  },
  props: {
    uuid: {
      type: String,
      required: true
    }
  },
  methods: {
    facebook,
    twitter,
    whatsapp
  },
  computed: {
    loaded() {
      return this.$store.state.loaded
    },
    rounds() {
      return this.$store.state.rounds
    },
    nominees() {
      return this.$store.state.nominees.filter(({ id }) => this.nomineeIds.includes(id))
    },
    categories() {
      return this.$store.state.categories
    },
    shareText() {
      const nominees = this.votedNominees.map(
        ({ name, hashtag }) => name + (hashtag && hashtag.length ? ` (${hashtag})` : '')
      )

      const sentence = [...nominees].reduce((acc, curr, index, names) => {
        if (index === 0) {
          return curr
        }

        return index < names.length - 1 ? `${acc}, ${curr}` : `${acc} en ${curr}`
      }, '')

      return `Ik heb gestemd op ${sentence}. Stem nu ook!`
    }
  },
  mounted() {
    get(`voting/vote/confirm/${this.uuid}`)
      .then(response => {
        if (response.ok) {
          response.json().then(({ data }) => {
            const { confirmed, replay, notFound, nominees, suggestions } = data
            this.confirmed = confirmed
            this.replay = replay
            this.notFound = notFound
            this.suggestions = suggestions
            this.nomineeIds = nominees.map(Number)
            this.loading = false

            get(`voting/votes/${this.uuid}`)
              .then(response => response.json())
              .then(({ data }) => {
                const { votes } = data
                this.votedNominees = votes
              })
          })
        } else {
          this.notFound = true
          this.loading = false
        }
      })
      .catch(() => {
        this.notFound = true
        this.loading = false
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Confirm.vue